import React, { useState, useEffect } from "react";
import CountUp from "react-countup"; // Import CountUp
import "./component.css";
import { URL, ADMIN } from "../../../lib/lib.js";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    user: 0,
    hotel: 0,
    category: 0,
    product: 0,
    menu: 0,
    coupon: 0,
    order: 0,
  });

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const request = await fetch(URL + ADMIN.dashboard, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include"
        });

        let response = await request.json();
        setDashboardData(response.data);
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchDashboardData();
  }, []);

  return (
    <div>
      <div className="padd-dash">
        <h3 className="head-dash">Dashboard</h3>
        <div className="row g-4">

          {/** Users Counter */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div className="dash_card mt-2 mb-2 ">
              <div>
                <h3 className="mb-0 mb-2">
                  <CountUp
                    start={0}
                    end={dashboardData.user}
                    duration={2.5}
                    delay={0.5}
                  />
                </h3>
                <p className="text-muted">Users</p>
              </div>
              <div>
                <div className="my_icon">
                  <i className="ri-user-line"></i>
                </div>
              </div>
            </div>
          </div>

          {/** Hotels Counter */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div className="dash_card mt-2 mb-2 ">
              <div>
                <h3 className="mb-0 mb-2">
                  <CountUp
                    start={0}
                    end={dashboardData.hotel}
                    duration={2.5}
                    delay={0.5}
                  />
                </h3>
                <p className="text-muted">Hotels</p>
              </div>
              <div>
                <div className="my_icon">
                  <i className="ri-hotel-line"></i>
                </div>
              </div>
            </div>
          </div>

          {/** Categories Counter */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div className="dash_card mt-2 mb-2">
              <div>
                <h3 className="mb-0 mb-2">
                  <CountUp
                    start={0}
                    end={dashboardData.category}
                    duration={2.5}
                  />
                </h3>
                <p className="text-muted">Categories</p>
              </div>
              <div>
                <div className="my_icon2">
                  <i className="ri-folder-line"></i>
                </div>
              </div>
            </div>
          </div>

          {/** Products Counter */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div className="dash_card mt-2 mb-2">
              <div>
                <h3 className="mb-0 mb-2">
                  <CountUp
                    start={0}
                    end={dashboardData.product}
                    duration={2.5}
                  />
                </h3>
                <p className="text-muted">Products</p>
              </div>
              <div>
                <div className="my_icon3">
                  <i className="ri-shopping-bag-line"></i>
                </div>
              </div>
            </div>
          </div>

          {/** Menu Counter */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div className="dash_card mt-2 mb-2">
              <div>
                <h3 className="mb-0 mb-2">
                  <CountUp
                    start={0}
                    end={dashboardData.menu}
                    duration={2.5}
                  />
                </h3>
                <p className="text-muted">Menu</p>
              </div>
              <div>
                <div className="my_icon5">
                  <i className="ri-menu-line"></i>
                </div>
              </div>
            </div>
          </div>

          {/** Coupons Counter */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div className="dash_card mt-2 mb-2">
              <div>
                <h3 className="mb-0 mb-2">
                  <CountUp
                    start={0}
                    end={dashboardData.coupon}
                    duration={2.5}
                  />
                </h3>
                <p className="text-muted">Coupons</p>
              </div>
              <div>
                <div className="my_icon4">
                  <i className="ri-coupon-line"></i>
                </div>
              </div>
            </div>
          </div>

          {/** Orders Counter */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div className="dash_card mt-2 mb-2">
              <div>
                <h3 className="mb-0 mb-2">
                  <CountUp start={0} end={dashboardData.order} duration={2.5} />
                </h3>
                <p className="text-muted">Orders</p>
              </div>
              <div>
                <div className="my_icon6">
                  <i className="ri-shopping-cart-2-line"></i>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
